module.exports = __webpack_public_path__ + "img/recent-work-02.e084fff6.jpg";